/* eslint-disable max-len */
import { MenuListItemProps } from '../components/menus/menu-list';
import { CurrentState, SelectingState, State } from './menu-list.slice';

export const getAvailableItems = (state: { menuList: State }): MenuListItemProps[] => state.menuList.available as MenuListItemProps[];
export const getSelectedItems = (state: { menuList: State }): MenuListItemProps[] => state.menuList.selected as MenuListItemProps[];
export const getSearchString = (state: { menuList: State }): string => state.menuList.search;
export const getPage = (state: { menuList: State }): number => state.menuList.page;
export const getCurrentState = (state: { menuList: State }): CurrentState => state.menuList.current;
export const getSelectingState = (state: { menuList: State }): SelectingState => state.menuList.selectingState;
export const getHasNothingAvailable = (state: {
  menuList: State
}): boolean => state.menuList.current === CurrentState.nothingAvailable;
export const getHasSelectedAll = (state: {
  menuList: State
}): boolean => state.menuList.selectingState === SelectingState.allAvailable;
export const getHasSelectedAllExisting = (state: {
  menuList: State
}): boolean => state.menuList.selectingState === SelectingState.allExisting;
export const getTotalExistingItems = (state: {
  menuList: State
}): number => state.menuList.totalCount;
